import { ApiUrls } from '../../../../../api/api/apiUrls';
import { useGetCachedPaginatedData } from '../../../../../api/cachedDataHooks';
import { FileMetadataDto } from '../../../../api';
import { validationUtils } from '../../../../utils/validationFunctions';

export const useCompanyRegistrationFileData = (registrationId: string, fetchManual?: boolean) => {
    const {
        data: companyRegistrationFileData,
        isFetching: isCompanyRegistrationFileDataFetching,
        refetch: refetchCompanyRegistrationFileData,
    } = useGetCachedPaginatedData<FileMetadataDto[]>({
        url: ApiUrls.userApi.registrationFileById(registrationId),
        queryKey: 'FILES',
        dataId: `${registrationId}/files`,
        enabled: !fetchManual && !validationUtils.isStringEmpty(registrationId),
    });
    const companyIntroductionFile = companyRegistrationFileData
        ? (companyRegistrationFileData as FileMetadataDto[])
        : [];

    return {
        companyIntroductionFile,
        isCompanyRegistrationFileDataFetching,
        refetchCompanyRegistrationFileData,
    };
};
